export default `uniform sampler2D uTexture;
varying float vAlpha;
varying float vRotation;

void main() {
    float mid = 0.5;
    vec2 rotatedUV = vec2(
        cos(vRotation) * (gl_PointCoord.x - mid) + sin(vRotation) * (gl_PointCoord.y - mid) + mid,
        cos(vRotation) * (gl_PointCoord.y - mid) - sin(vRotation) * (gl_PointCoord.x - mid) + mid
    );

    vec4 textureColor = texture2D(uTexture, rotatedUV);
    
    
    gl_FragColor = textureColor * vec4(0.5, 0.9, 0.7, 0.2) * vAlpha;
}`